export const NAV = {
  dashboardLink: "nav-dashboard-link",
  sourcesLink: "nav-sources-link",
  propertiesLink: "nav-properties-link",
  runsLink: "nav-runs-link",
  brand: "nav-brand",
};

export const DASHBOARD = {
  root: "dashboard-page",
  statTotal: "stat-total-properties",
  statSources: "stat-active-sources",
  statRuns: "stat-total-runs",
  statAmount: "stat-total-amount",
  runAllBtn: "dashboard-run-all-btn",
  latestRunCard: "dashboard-latest-run",
  topStatesCard: "dashboard-top-states",
  analyticsCard: "dashboard-analytics",
  histogramCard: "dashboard-histogram",
  topCountiesCard: "dashboard-top-counties",
};

export const SOURCES = {
  root: "sources-page",
  card: (id) => `source-card-${id}`,
  runBtn: (id) => `source-run-btn-${id}`,
  runAllBtn: "sources-run-all-btn",
};

export const PROPERTIES = {
  root: "properties-page",
  searchInput: "properties-search-input",
  stateSelect: "properties-state-select",
  citySelect: "properties-city-select",
  jurisdictionSelect: "properties-jurisdiction-select",
  statusSelect: "properties-status-select",
  sourceSelect: "properties-source-select",
  minAmount: "properties-min-amount",
  maxAmount: "properties-max-amount",
  applyFiltersBtn: "properties-apply-filters",
  clearFiltersBtn: "properties-clear-filters",
  exportCsvBtn: "properties-export-csv",
  exportJsonBtn: "properties-export-json",
  table: "properties-table",
  row: (id) => `property-row-${id}`,
  pageNext: "properties-page-next",
  pagePrev: "properties-page-prev",
  drawer: "property-drawer",
  drawerClose: "property-drawer-close",
};

export const RUNS = {
  root: "runs-page",
  row: (id) => `run-row-${id}`,
};
